import React from 'react';
import PropTypes from 'prop-types';
import {
    CardBody,
    CardContent,
    CardDesc,
    CardHeader,
    CardV2,
    CheckboxControl,
    Col,
    Container,
    Row,
} from '@si-armes/dsfr-react';

const CarteMobileCEAF = ({ arme, toggleArme, armesSelectionnees }) => {
    return (
        <Col col={6} className="padding-carte">
            <CardV2 noEnlargeLink>
                <CardHeader>
                    <Container>
                        <Row className="boutons-carte">
                            <Col offset={11}>
                                <CheckboxControl
                                    checked={armesSelectionnees.includes(arme.uniquid)}
                                    id={`selectCEAF-${arme.numeroEncodage}`}
                                    aria-label={`Ajouter l'arme ${arme.numeroEncodage} à ma ceaf`}
                                    label=""
                                    name={`selectCEAF-${arme.numeroEncodage}`}
                                    onClick={() => toggleArme(arme)}
                                />
                            </Col>
                        </Row>
                    </Container>
                </CardHeader>

                <CardBody>
                    <CardContent>
                        <CardDesc>
                            <p>
                                <b>Numéro d'encodage </b>: {arme.numeroEncodage}
                            </p>
                            <p>
                                <b>Numéro de série </b>: {arme.numeroCarcasse}
                            </p>
                            <p>
                                <b>Type </b>: {arme.type}
                            </p>
                            <p>
                                <b>Marque </b>: {arme.marque}
                            </p>
                            <p>
                                <b>Modèle </b>: {arme.modele}
                            </p>
                            <p>
                                <b>Calibre Canon 1 </b>: {arme.calibreCanon}
                            </p>
                            <p>
                                <b>Calibre Canon 2 </b>: {arme.calibreCanonDeux}
                            </p>
                            <p>
                                <b>Classement </b>: {arme.classement}
                            </p>
                            <p>
                                <b>Classement UE </b>: {arme.classementEuropeen}
                            </p>
                        </CardDesc>
                    </CardContent>
                </CardBody>
            </CardV2>
        </Col>
    );
};

CarteMobileCEAF.propTypes = {
    arme: PropTypes.array.isRequired,
    armesSelectionnees: PropTypes.array.isRequired,
    toggleArme: PropTypes.func.isRequired,
};

export default CarteMobileCEAF;
